import React from "react";
import clsx from "clsx";
import type { EcoConsumptionCostsAreaType, EcoConsumptionCostEntryType } from "../types/EcoConsumptionType";
import styles from "./SpecEcoConsumption.module.scss";
import { useEcoConsumptionLabel } from "../utils/labels";

export const CostsEcoConsumptionArea: React.FC<
    EcoConsumptionCostsAreaType & { getDisclaimerIndex: (disclaimer: SanitizedString) => number }
> = (props) => {
    const { title, subtitle, yearlyMilageEnergyCosts, co2Costs, total } = props;
    const { getDisclaimerIndex } = props;

    const [ecoConsumptionCostPerYearUnit] = useEcoConsumptionLabel(["ecoConsumptionCostPerYearUnit"]);

    const getDisclaimerForPrice = (priceEntry: EcoConsumptionCostEntryType): JSX.Element | null => {
        if (!priceEntry.disclaimer) return null;
        return <sup>{getDisclaimerIndex(priceEntry.disclaimer)}</sup>;
    };
    return (
        <div className={clsx(styles.wrapper, styles.listwrapper)}>
            {title && <h4 className={styles.title}>{title}</h4>}
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
            {yearlyMilageEnergyCosts && (
                <dl className={clsx(styles.list, styles["list-costs"])}>
                    <dt data-highlighted={yearlyMilageEnergyCosts.highlighted}>{yearlyMilageEnergyCosts.title}</dt>
                    <dd data-highlighted={yearlyMilageEnergyCosts.highlighted}>
                        {yearlyMilageEnergyCosts.price}
                        {ecoConsumptionCostPerYearUnit}
                    </dd>
                    {yearlyMilageEnergyCosts.subtitle && <dt>{yearlyMilageEnergyCosts.subtitle}</dt>}
                </dl>
            )}
            {co2Costs.length && (
                <dl className={clsx(styles.list, styles["list-costs"])}>
                    {co2Costs.map((cost, index) => (
                        <React.Fragment key={`eco-consumption-co2-cost-${index + 1}`}>
                            <dt data-highlighted={cost.highlighted}>
                                {cost.title}
                                {getDisclaimerForPrice(cost)}
                            </dt>
                            <dd data-highlighted={cost.highlighted}>{cost.price}</dd>
                        </React.Fragment>
                    ))}
                </dl>
            )}

            {total && (
                <dl className={clsx(styles.list, styles["list-costs"])}>
                    <dt data-highlighted={total.highlighted}>{total.title}</dt>
                    <dd data-highlighted={total.highlighted}>
                        {total.taxExempt || `${total.price || ""}${ecoConsumptionCostPerYearUnit}`}
                        {getDisclaimerForPrice(total)}
                    </dd>
                    {total.subtitle && <p>{total.subtitle}</p>}
                </dl>
            )}
        </div>
    );
};
